import { NgIf } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';
import { Nl2brPipe } from 'app/shared/pipes';
import { SnackBarData } from 'app/shared/types/snackbar-data';

@Component({
  selector: 'app-custom-snackbar',
  templateUrl: './custom-snackbar.component.html',
  imports: [MatIcon, NgIf, TranslateModule, Nl2brPipe],
})
export class CustomSnackbarComponent implements OnInit {
  public isMultinline = false;

  constructor(
    private snackBarRef: MatSnackBarRef<CustomSnackbarComponent>,
    @Inject(MAT_SNACK_BAR_DATA)
    public data: SnackBarData
  ) {}

  public ngOnInit(): void {
    this.isMultinline = this.isMultiLineMessage();
    if (this.isMultinline && !this.data.hideActions) {
      this.data.action = 'Action';
    }
  }

  public onAction(): void {
    if (this.data.onAction) {
      this.data.onAction();
    }
    this.snackBarRef.dismiss();
  }

  public close(): void {
    this.snackBarRef.dismiss();
  }

  public isMultiLineMessage(): boolean {
    return this.data.message.length > 100;
  }
}
